import {
  CommonIncidentId,
  VolleyballEventStatusId,
  VolleyballIncidentId,
} from '@collector/sportsapi-client-legacy'

import {
  getBlockedPocketIncidentsMap,
  PocketIncidents,
  PocketIncidentsConfig,
} from '../../configuration'

const pocketIncidents: PocketIncidents = [
  {
    incidentId: VolleyballIncidentId.Timeout,
    title: 'Timeout',
  },
  {
    incidentId: VolleyballIncidentId.TimeoutOver,
    title: 'Timeout over',
  },
  {
    incidentId: VolleyballIncidentId.RefereeChallenge,
    title: 'Ref. challenge',
  },
  {
    incidentId: CommonIncidentId.TechnicalProblems,
    title: 'Tech. problem',
  },
]

const morePocketIncidents: PocketIncidents = [
  {
    incidentId: CommonIncidentId.MatchResumed,
    title: 'Match resumed',
  },
  {
    incidentId: VolleyballIncidentId.RepeatAction,
    title: 'Repeat action',
  },
  {
    incidentId: VolleyballIncidentId.PlayerChangeSides,
    title: 'Players change sides',
  },
  {
    incidentId: VolleyballIncidentId.BreakDuringTheGame,
    title: 'Break during the game',
  },
]

const blockedStatuses: VolleyballEventStatusId[] = [
  VolleyballEventStatusId.Abandoned,
  VolleyballEventStatusId.Cancelled,
  VolleyballEventStatusId.NotStarted,
  VolleyballEventStatusId.StartDelayed,
  VolleyballEventStatusId.Postponed,
  VolleyballEventStatusId.FinishedAwardedWin,
  VolleyballEventStatusId.Interrupted,
  VolleyballEventStatusId.Finished,
  VolleyballEventStatusId.ToFinish,
  VolleyballEventStatusId.BreakAfterFifthSet,
  VolleyballEventStatusId.BreakAfterFourthSet,
  VolleyballEventStatusId.BreakAfterThirdSet,
  VolleyballEventStatusId.BreakAfterSecondSet,
  VolleyballEventStatusId.BreakAfterFirstSet,
]

const blockedPocketIncidentsMap = getBlockedPocketIncidentsMap(
  pocketIncidents,
  morePocketIncidents,
  blockedStatuses,
)

export const pocketIncidentsConfig: PocketIncidentsConfig = {
  pocketIncidents,
  morePocketIncidents,
  blockedPocketIncidentsMap,
}
